<template>
  <div class="page-wrapper">
    <div class="content-wrapper">
      <loading v-model:active="isLoading" :is-full-page="true"/>
      
      <div class="header-container">
        <img class="uni-logo" :src="`${publicPath}assets/logo.png`"/>
        <div class="title-container">
          <h1>Login</h1>
        </div>
      </div>

      <div class="content-block">
        <div class="info-card">
          <p>Please enter username/password</p>

          <form v-on:submit.prevent="onSubmit">
            <div class="form-group">
              <label>Username</label>
              <input v-model="email"/>
            </div>

            <div class="form-group">
              <label>Password</label>
              <div class="password-group">
                <input :type="passwordVisibility" v-model="password" />
                <i v-if="passwordVisibility === 'password'" class="far fa-eye-slash" @click="togglePasswordVisibility"></i>
                <i v-if="passwordVisibility === 'text'" class="far fa-eye" @click="togglePasswordVisibility"></i>
              </div>
            </div>

            <div class="action-buttons">
              <button type="submit" class="btn-primary">
                <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"/>
                </svg>
                Login
              </button>
              <div class="btn-group">
                <button type="button" class="btn-secondary" @click="goToRegister">
                  <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  Register
                </button>
                <button type="button" class="btn-secondary" @click="goToHome">
                  <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                  </svg>
                  Home
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { useToast } from "vue-toastification";
import authStore from "../store/auth-store";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      isLoading: false,
      email: "",
      password: "",
      passwordVisibility: 'password'
    }
  },

  methods: {
    togglePasswordVisibility() {
      this.passwordVisibility = this.passwordVisibility === 'password' ? 'text' : 'password';
    },
    
    async onSubmit() {
      if (this.email === "" || this.password === "") {
        this.toast.error("Please enter both username and password");
        return; 
      }
      
      this.isLoading = true;

      const dto = {
        username: this.email,
        password: this.password
      };

      try {
        const response = await this.axios.post("/api/auth/authenticate", dto);
        this.isLoading = false;
        this.toast.success("Successfully logged in");
        authStore.commit("setUser", response.data);
        this.$router.push("/");
      } catch (error) {
        this.toast.error("Invalid username/password");
        this.isLoading = false;
      }
    },
    
    goToRegister() {
      this.$router.push("/demographic");
    },
    
    goToHome() {
      this.$router.push("/");
    }
  },
  
  components: {
    Loading
  },
}
</script>

<style lang="scss" scoped>
@import "../breakpoints.scss";

.page-wrapper {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.content-wrapper {
  margin: 0 auto;
  padding: 20px;
}

.header-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  text-align: center;
  
  @include md {
    align-items: center;
    gap: 20px;
  }
  
  .uni-logo {
    max-width: 180px;
    margin-bottom: 20px;
    
    @include md {
      margin-bottom: 0;
    }
  }
  
  .title-container {
    text-align: center;
  }
}

h1 {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 5px;
  line-height: 1.3;
}

.content-block {
  max-width: 650px;
  margin: 0 auto 40px;
}

.info-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 30px;
  border: 1px solid #E5E7EB;
}

p {
  line-height: 1.6;
  color: #000001;
  margin: 0 0 20px 0;
  font-size: 15px;
}

form {
  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;

    label {
      font-weight: bold;
      text-align: left;
      margin-bottom: 5px;
      color: #000001;
      font-size: 15px;
    }

    input {
      padding: 10px 12px;
      border: 1px solid #D1D5DB;
      border-radius: 8px;
      font-size: 15px;
      
      &:focus {
        outline: none;
        border-color: #013B82;
        box-shadow: 0 0 0 2px rgba(1, 59, 130, 0.1);
      }
    }
  }
}

.password-group {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  overflow: hidden;
  
  &:focus-within {
    border-color: #013B82;
    box-shadow: 0 0 0 2px rgba(1, 59, 130, 0.1);
  }
  
  input {
    flex: 1;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    
    &:focus {
      border: none !important;
      box-shadow: none !important;
    }
  }
  
  i {
    padding: 0 15px;
    cursor: pointer;
    color: #6B7280;
  }
}

.action-buttons {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.btn-primary, .btn-secondary, .btn-accent {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.2s ease;
  cursor: pointer;
  width: 100%;
  margin: 10px 0;
  border: none;
  
  .btn-icon {
    flex-shrink: 0;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #013B82, #0A2D5C);
  color: white;
  box-shadow: 0 2px 6px rgba(1, 59, 130, 0.2);
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(1, 59, 130, 0.3);
    background-color: #0056b3;
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(1, 59, 130, 0.2);
  }
}

.btn-secondary {
  background: white;
  color: #000001;
  border: 1px solid #D1D5DB;
  
  &:hover {
    background: #F9FAFB;
    color: #111827;
    border-color: #9CA3AF;
  }
  
  &:active {
    background: #F3F4F6;
  }
}

.btn-accent {
  background-color: #013B82;
  color: white;
  font-size: 14px;
}

.btn-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

@include md {
  .content-wrapper {
    padding: 30px;
  }
}
</style>